// Lazy installer for v-viewer (the <viewer> component, v-viewer directive, and $viewerApi method).
// v-viewer is used on ~29 components — effectively all AUTHENTICATED pages (admin/employer/jobseeker
// profiles, tickets, tables, marketing). The router guard installs it by AUTH STATE (not per-route
// enumeration): once the user is logged in it loads on their first authed page; logged-out visitors on
// public pages (homepage/listings/blog/FT-PT — what PageSpeed measures) never load viewerjs.
// NOTE: the sole PUBLIC v-viewer consumer (website/WebEmpProfileView, logged-out only) is intentionally
// NOT covered — its lightbox won't open for logged-out viewers (accepted trade-off). The dynamic imports
// keep the JS + CSS in the async "v-viewer" chunk. Idempotent.
import Vue from "vue";

let installPromise = null;

export default function ensureViewer() {
  if (!installPromise) {
    installPromise = Promise.all([
      import(/* webpackChunkName: "v-viewer" */ "v-viewer"),
      import(/* webpackChunkName: "v-viewer" */ "viewerjs/dist/viewer.css"),
    ]).then(function (mods) {
      var viewer = mods[0];
      Vue.use(viewer.default || viewer);
    });
  }
  return installPromise;
}
